import styled, { css, keyframes } from 'styled-components';

import * as mx from 'core/styles/mixins';
import * as vr from 'core/styles/variables';

import { Icon } from 'core/components/Icon/Icon.style';
import { Label } from 'pods/forms/components/base/Label/Label.style';

const spin = keyframes`
  0% {
	transform:rotate(0deg);
  }
  100% {
    transform:rotate(360deg);
  }
`;

export const LoadingMessage = (styled.div as any)`
	margin-top: 5px;
	color: ${({ theme }: any) => theme.global.typography.colors.subdued}
	font-size: ${vr.formfieldErrorMessageFontSize};
	display: flex;
	align-items: center;
`;

export const SpinningCheckIcon = (styled.div as any)`
	display: flex;

	${Icon} {
		margin-right: 4px;
		animation: ${spin} 2s linear infinite;
		color: ${({ theme }: any) => theme.global.typography.colors.subdued};
	}
`;

export const ErrorMessage = styled.div`
	margin-top: 5px;
	color: ${vr.formfieldErrorColor};
	font-size: ${vr.formfieldErrorMessageFontSize};
	display: flex;
	align-items: center;

	& > i {
		margin-right: 4px;
	}

	/* This gives the error message container some invisible content when the
	error message un-renders, making for a smoother closing animation of <Collapse/> */
	&::after {
		content: '-';
		font-size: inherit;
		color: transparent;
	}
`;

export const SuccessMessage = styled.div`
	margin-top: 5px;
	color: green;
	font-size: ${vr.formfieldErrorMessageFontSize};
	display: flex;
	align-items: center;

	& > i {
		margin-right: 4px;
	}

	/* This gives the error message container some invisible content when the
	error message un-renders, making for a smoother closing animation of <Collapse/> */
	&::after {
		content: '-';
		font-size: inherit;
		color: transparent;
	}
`;

export const HelpText = styled.span`
	margin-top: 12px;
	font-size: ${vr.formfieldHelpTextFontSize};
	display: block;
`;

export const LabelContents = styled.div``;

export const FieldContents = styled.div`
	flex-grow: 1;
`;

export const Field = styled.div<{
	hasAppendMsg: boolean;
}>`
	${({ hasAppendMsg }) =>
		!!hasAppendMsg &&
		css`
			margin: 0 0 20px 0;

			${mx.bp('s')`
				width: 200px;
				margin: 0 30px 0 0;
				display: inline-block;
			`}
		`}
`;

export const CtrlHolder = styled.div<{
	hasError: boolean;
	noMargin: boolean;
}>`
	margin: ${({ noMargin }) => (noMargin ? 0 : vr.formCtrlHolderSpacing)} 0;
	position: relative;
	display: flex;
	flex-direction: column;

	&:first-of-type {
		margin-top: 0;
	}

	${({ hasError }) =>
		hasError &&
		css`
			${Label} {
				color: ${vr.formfieldErrorColor};
			}
		`}
`;

export const BottomMessage = styled.div`
	margin-top: 8px;
	font-size: ${vr.formfieldHelpTextFontSize};
	color: ${vr.formfieldLabelOptionalColor};
`;
